<template>
  <el-table :data="value" border style="width: 100%">
    <el-table-column prop="company_name" label="供应商" />
    <el-table-column label="采购成本">
      <template slot-scope="scope">
        <el-input :value="scope.row.cost" @input="handleChange('cost', $event, scope.$index)" />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import { Vue, Component, Model, Emit } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class CostEditTable extends Vue {
    @Model('change', { type: Object, default: () => ([]) }) value;

    @Emit('change')
    handleChange(column, val, index) {
      const value = _.cloneDeep(this.value);
      value[index][column] = val;
      return value;
    }
  }
</script>
